import { isEmpty } from "@swiggy-private/js-utils";
import { ObjectNames } from "@swiggy-private/portal-dineout-context";
import { IPaymentCard, IPaymentOffer, IPaymentOption, IPaymentType, ITitleSegments } from "./types";

export const getOffersToShow = (
    offers: IPaymentOffer[] | undefined,
    shownOfferLimit: number | undefined,
    isExpanded: boolean
): IPaymentOffer[] => {
    const offersList = offers || [];
    if (isExpanded || !shownOfferLimit) {
        return offersList;
    }
    return offersList.slice(0, shownOfferLimit);
};

export const getRemainingOffersCount = (
    offers: IPaymentOffer[] | undefined,
    shownOfferLimit: number | undefined,
    isExpanded: boolean
): number => {
    const offersList = offers || [];
    if (!shownOfferLimit || isExpanded) {
        return 0;
    }
    return Math.max(0, offersList.length - shownOfferLimit);
};

export const parseTitleSegments = (title: string): ITitleSegments => {
    const STRIKETHROUGH_TOKEN = "{strikethrough_amount}";
    const FINAL_AMOUNT_TOKEN = "{final_amount}";

    // If title doesn't contain strikethrough token, treat entire title as beforeStrike
    if (!title.includes(STRIKETHROUGH_TOKEN)) {
        return {
            beforeStrike: title.trim(),
            middle: "",
            afterFinalAmount: "",
        };
    }

    const [beforeStrike = "", afterStrike = ""] = title.split(STRIKETHROUGH_TOKEN);

    // If afterStrike doesn't contain final_amount token, treat it as middle
    if (!afterStrike.includes(FINAL_AMOUNT_TOKEN)) {
        return {
            beforeStrike: beforeStrike.trim(),
            middle: afterStrike.trim(),
            afterFinalAmount: "",
        };
    }

    const [middle = "", afterFinalAmount = ""] = afterStrike.split(FINAL_AMOUNT_TOKEN);

    return {
        beforeStrike: beforeStrike.trim(),
        middle: middle.trim(),
        afterFinalAmount: afterFinalAmount.trim(),
    };
};

export const shouldRenderMiddleSegment = (middle: string): boolean => {
    return !isEmpty(middle);
};

export interface IProcessCardParams {
    card: IPaymentCard;
    shownOfferLimit: number;
}

export const processCard = ({ card, shownOfferLimit }: IProcessCardParams): IPaymentOption => {
    return {
        ...card,
        id: card.type,
        shownOfferLimit,
    };
};

export const getObjectNameByCardType = (cardType: IPaymentType): string => {
    switch (cardType) {
        case IPaymentType.SWIGGY:
            return ObjectNames.CLICK_PAYMENT_CARD_SWIGGY;
        case IPaymentType.RAZORPAY:
            return ObjectNames.CLICK_PAYMENT_CARD_RAZORPAY;
        default:
            return "";
    }
};
